<div style="padding: 1rem">
  <div class="md3-card-on-surface" style="padding: 1rem; margin-bottom: 1rem">
    <div class="grid-1-auto" style="padding-bottom: 0.5rem">
      <h6>{{getResource('UploadStamp')}}</h6>
    </div>

    <input #stempelFileInput
           type="file"
           accept="image/png,image/jpeg,image/gif"
           style="display:none"
           (change)="onFileSelected($event)">

    <ng-container *ngIf="!upload.preview">
      <button class="md-btn" (click)="stempelFileInput.click()">
        <i class="far fa-upload"></i> {{getResource('SelectImage')}}
      </button>
    </ng-container>

    <ng-container *ngIf="upload.preview">
      <div style="padding: 0.75rem; display:flex; align-items:flex-start; gap:1rem; flex-wrap:wrap">
        <img [src]="upload.preview" alt="Vorschau"
             style="max-width:160px; max-height:160px; object-fit:contain; border:1px solid var(--c-dark-m2)">
        <div style="flex:1; min-width:12rem">
          <exg-input
            name="stempelName"
            caption="Name"
            [maxlength]="256"
            [(ngModel)]="upload.name">
          </exg-input>
          <div class="spawn-reverse" style="padding-top: 0.5rem">
            <button class="md-btn" type="button"
                    (click)="cancelUpload()">
              {{getGlobal('Cancel')}}
            </button>
            <button class="md-btn" type="button"
                    [disabled]="!upload.name || saving"
                    (click)="save()">
              <i *ngIf="saving" class="far fa-spin fa-spinner"></i>
              {{getGlobal('Save')}}
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <div *ngIf="state === 2" class="splash empty">
    <p>{{getResource('Ghost')}}</p>
  </div>

  <div *ngIf="state === 0" class="md3-card-on-surface">
    <div *ngFor="let s of list" class="list-row app-document-list-row">
        <div class="grid-auto-1" style="padding: 0.5rem">
          <div style="cursor: pointer" class="list-avatar-placeholder"
               (click)="previewStempel(s)">
          <span flow="right" style="font-size: medium" [tooltip]="'Vorschau'">
            <img [src]="s.stpData" [alt]="s.stpName"
                 class="list-avatar-placeholder"
                 style="object-fit:contain"/>
          </span>
          </div>
        <div class="layout-auto-1-auto-grid-1-auto grid typo-small">
          <div class="list-metadata" style="margin-left:0">
            <div>{{getResource('Stamp')}}</div>
          </div>
          <div class="list-metadata">
            <div class="typo-right">{{s.stpCRD | excDate: 'Globals.DateTimeFormatShort'}}</div>
            <div class="typo-right">{{s.stpCRU}}</div>
          </div>
          <div class="span-2">
            <div class="grid-1-auto">
              <div style="overflow:hidden">
                <ng-container *ngIf="!s._renaming">
                  <strong>{{s.stpName}}</strong>
                </ng-container>
                <ng-container *ngIf="s._renaming">
                  <exg-input name="stempelRename"
                             caption="Name"
                             [maxlength]="256"
                             [(ngModel)]="s._newName"
                             (keydown.enter)="saveRename(s)">
                  </exg-input>
                </ng-container>
              </div>
              <div class="typo-right app-space-top_1">
                <span flow="left" style="font-size:medium" [tooltip]="getGlobal('Preview')">
                  <i class="search-action fa-duotone fa-eye"
                     (click)="previewStempel(s)"></i>
                </span>
                <span flow="left" style="font-size:medium" [tooltip]="getGlobal('Rename')">
                  <i class="search-action fa-duotone fa-pencil-alt"
                     (click)="renameStempel(s)"></i>
                </span>
                <span flow="left" style="font-size:medium" [tooltip]="getGlobal('Delete')">
                  <i class="search-action fa-duotone fa-trash-alt"
                     (click)="confirmDelete(s)"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
